<template>
  <section class="td-similar" :style="box" v-if="posts && posts.length">
    <div :class="container">
      <div class="td-similar__title">
        <h2 class="h2">
          Aðrar umfjallanir
        </h2>
      </div>

      <ul class="td-similar__cards">
        <router-link
          class="td-similar__card"
          v-for="{id, title, model, image , link} in convertPosts"
          :key="id"
          :to="link"
        >
          <div class="td-similar__card_image">
            <img :src="image" alt="">
          </div>
          <div class="td-similar__card_title">
            <b>{{title}}</b>
          </div>
          <div class="td-similar__card_model">
            <p>{{model}}</p>
          </div>
        </router-link>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import mixin from '@/mixins/sections/styleSettings'
import getBlogImg from "@/helpers/getBlogImg";
export default {
  mixins: [mixin],
  methods: {
    ...mapActions('blog', {
      similarPosts: 'GET_SIMILAR_POSTS'
    })
  },
  computed: {
    ...mapState('blog', {
      category: state => state.category
    }),
    ...mapGetters('blog', {
      posts: 'GET_SIMILAR_POSTS',
      mainDataPage: 'GET_MAIN_DATA_SIMPLE_PAGE'
    }),
    convertPosts() {
      return this.posts.map(post => ({
        id: post.id,
        title: post.title || 'No title',
        model: post.description,
        image: getBlogImg(post.img && post.img.file_name),
        link: post.id.toString()
      })).slice(0,4)
    }
  },
  created() {
    const categoryId = this.mainDataPage && this.mainDataPage.categoryId
    const limit = 4
    this.similarPosts({
      categoryId: categoryId,
      limit: limit
    })
  }
}
</script>
